/**
 * Anonymous ID for consent_logs (no PII). Persisted in localStorage, reused.
 */

const KEY = "dsos_anon_id";
const MIN_LEN = 8;
const MAX_LEN = 128;

function randomFallback(): string {
  const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
  let s = "";
  for (let i = 0; i < 32; i++) {
    s += chars[Math.floor(Math.random() * chars.length)];
  }
  return s;
}

/**
 * Returns existing anon_id from localStorage if valid (8..128 chars), otherwise
 * generates one (crypto.randomUUID or fallback), saves it, and returns it.
 * Returns "" if window/localStorage unavailable (no crash).
 */
export function getOrCreateAnonId(): string {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return "";
  }
  try {
    const existing = localStorage.getItem(KEY);
    if (existing != null && existing.length >= MIN_LEN && existing.length <= MAX_LEN) {
      return existing;
    }
    const id = typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : randomFallback();
    if (id.length >= MIN_LEN && id.length <= MAX_LEN) {
      localStorage.setItem(KEY, id);
      return id;
    }
    const safe = id.slice(0, MAX_LEN);
    localStorage.setItem(KEY, safe);
    return safe;
  } catch {
    return "";
  }
}

/**
 * Returns current anon_id from localStorage without creating. null if missing or invalid.
 */
export function getAnonId(): string | null {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return null;
  }
  try {
    const existing = localStorage.getItem(KEY);
    if (existing != null && existing.length >= MIN_LEN && existing.length <= MAX_LEN) {
      return existing;
    }
  } catch {
    // ignore
  }
  return null;
}
